import { render, staticRenderFns } from "./addDesc.vue?vue&type=template&id=6084fe7e&"
import script from "./addDesc.vue?vue&type=script&lang=js&"
export * from "./addDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports